const textFieldFormParamFreq = {
  name: 'Nome',
  value: 'Valor'
};

export default textFieldFormParamFreq;
